import {
  Component,
  ComponentInterface,
  h,
  Prop,
} from '@stencil/core';

@Component({
  shadow: true,
  styleUrl: 'paf-no-results.scss',
  tag: 'paf-no-results',
})

export class PafNoResults implements ComponentInterface {

  /**
   * The heading text for the notification
   */
  @Prop() public headingText!: string;

  /**
   * The heading level for the title of the notification
   */
  @Prop() public headingLevel!: number;

  /**
   * The description for the notification
   */
  @Prop() public description!: string;

  public render(): HTMLDivElement {
    const HEADING_TAG = `h${this.headingLevel}`;

    return (
      <div
        class='notification'
      >
        <HEADING_TAG
          class='title'
        >
          {this.headingText}
        </HEADING_TAG>

        <p class='description'>{this.description}</p>
      </div>
    );
  }
}
